/**
 * Create a simple VuePlugin.
 * @param {Object} settings
 * @return {Object}
 */
export default function createVuePlugin(settings = {}) {
    settings = {
        defaults: {},
        install: null,
        version: '0.0.1',
        ...settings,
    };

    const plugin = {
        install(Vue, options) {
            if (!plugin.install.installed) {
                settings.options = { ...settings.defaults, ...options };

                if (typeof settings.install === 'function') {
                    settings.install.call(settings, Vue, settings.options);
                }

                plugin.install.installed = true;
            }
        },

        version: settings.version,
    };

    return plugin;
}
